export const versionInfo = {
  major: 1,
  minor: 1,
 git_hash: '76c46101'
};
